import React, { Component } from 'react';

import { UserService } from '../../_services';
import { CommonHelper, history, SVCMessage } from '../../_helpers';

export default class NetworkError extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  };

  componentWillMount() {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
  };

  render() {
    return (
      <div>
        Network error.Please try after sometime.
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/error-pages/network-error.js